import { render, staticRenderFns } from "./PaymentProfile.vue?vue&type=template&id=51c6a1b0&scoped=true"
import script from "./PaymentProfile.vue?vue&type=script&lang=js"
export * from "./PaymentProfile.vue?vue&type=script&lang=js"
import style0 from "./PaymentProfile.vue?vue&type=style&index=0&id=51c6a1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6a1b0",
  null
  
)

export default component.exports